// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1ebn57Zg","picTxt":"picTxt-3X0tEy72","pic":"pic-1Mz6wvbu","trans":"trans-1xX8gxFR","txt":"txt-1tJGTpEs"};